import { UtilsService } from './../../core/services/utils.service';
import { Denounce } from './../../core/models/denounce.model';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AppState } from '../../core/state/app.reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ComplaintConfirmationDeleteComponent } from '../modals/complaint-confirmation-delete/complaint-confirmation-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { ComplaintsService } from '../../core/services/complaints.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../core/services/user.service';

import * as fromComplaintsActions from '../../pages/home/state/complaints.actions';
import * as fromComplaintsSelector from '../../pages/home/state/complaints.selectors';

@Component({
	selector: 'app-last-denounces-table',
	templateUrl: './last-denounces-table.component.html',
	styleUrls: ['./last-denounces-table.component.scss'],
})
export class LastDenouncesTableComponent implements OnInit {

	SSE_EVENTS = [];
	sse$: Observable<Denounce[]>;

	private denounces: [Denounce?] = [];

	private complaints;
	private complaints$;

	private loading$;
	private su: Boolean;

	user = {
		phone: '',
		email: '',
		role: '',
		gender: '',
		name: ''
	};

	@Input() from;
	@Input() to;

	corte = 5;
	pagina = 0;
	listaDenuncias = [];
	dataSourceDenounces = new MatTableDataSource<any>(this.denounces);

	public displayedColumnsDenounces: string[] = [
		'id',
		'action',
		'date_created',
		'date',
		'status',
	];


	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	constructor(
		private store: Store<AppState>,
		public utilsService: UtilsService,
		public dialog: MatDialog,
		private complaintsService: ComplaintsService,
		private toastr: ToastrService,
		private userService: UserService,
		private paginatorTranslator: MatPaginatorIntl
	) { }

	ngOnInit(): void {
		this.translateTable();

		this.su = Boolean(localStorage.getItem('superUser'));

		this.complaints$ = this.store.pipe(
			select(fromComplaintsSelector.selectComplaintsEntities)
		);

		this.loading$ = this.store.pipe(
			select(fromComplaintsSelector.selectLoading)
		);

		this.complaints$.subscribe(() => {
			this.prepareData();
		});

		this.dataSourceDenounces.paginator = this.paginator;

		this.getUser()
	}

	prepareData(): void {
		this.complaints$.subscribe((complaintsList) => {
			this.denounces = [];

			let complaints = complaintsList;

			if (this.from && this.to) {
				complaints = complaints.filter(
					(denounce: { created_at: string | number | Date; }) =>
						new Date(denounce.created_at) >= this.from &&
						new Date(denounce.created_at) <= this.to
				);
			}

			complaints.forEach((complaint: Denounce) => {
				this.denounces.push(complaint);
			});

			this.dataSourceDenounces.data = this.denounces
				.sort((a, b) => (b.created_at > a.created_at ? 1 : -1))
				.slice(0, 100);
		});

		for (var i = 0; i < this.dataSourceDenounces.data.length; i = i + this.corte) {
			this.listaDenuncias.push(this.dataSourceDenounces.data.slice(i, i + this.corte));
		}


	}

	private portugueseRangeLabel(page: number, pageSize: number, length: number): string {
		if (length === 0 || pageSize === 0) { return `0 de ${length}`; }
	  
		length = Math.max(length, 0);
	  
		const startIndex = page * pageSize;
	  
		const endIndex = startIndex < length ?
			Math.min(startIndex + pageSize, length) :
			startIndex + pageSize;
	  
		return `${startIndex + 1} - ${endIndex} de ${length}`;
	  };

	private translateTable() {
		this.paginatorTranslator.itemsPerPageLabel = 'Itens por página:';
		this.paginatorTranslator.nextPageLabel = 'Página seguinte';
		this.paginatorTranslator.previousPageLabel = 'Página anterior';
		this.paginatorTranslator.firstPageLabel = 'Primeira página';
		this.paginatorTranslator.lastPageLabel = 'Última página';
this.paginatorTranslator.getRangeLabel = this.portugueseRangeLabel;
	}

	private updateComplaintOnStore(): void {
		this.store.dispatch(fromComplaintsActions.loadComplaints());
	}

	public deleteComplaint(denounce: any): void {
		this.complaintsService
			.deleteComplaint(denounce._id)
			.subscribe()
			.add(() => {
				this.updateComplaintOnStore();
				this.toastr.success('Denúncia deletada com sucesso!');
			});
	}

	public deleteComplaintFunc(data: any): void {
		const dialog = this.dialog.open(ComplaintConfirmationDeleteComponent, {
			panelClass: 'media-modal',
			width: '40%',
		})

		dialog.afterClosed().subscribe((response) => {
			if (response === true) {
				this.deleteComplaint(data);
			}
		});
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((userAtt) => {
			userAtt.UserAttributes.forEach((att) => {
				if (att.Name === 'phone_number') {
					this.user.phone = att.Value;
				} else if (att.Name === 'name') {
					this.user.name = att.Value;
				} else if (att.Name === 'gender') {
					this.user.gender = att.Value;
				} else if (att.Name === 'email') {
					this.user.email = att.Value;
				} else if (att.Name === 'custom:role') {
					this.user.role = att.Value;
				}
			});
			this.loading$ = false;
		});
	}

	change(event:PageEvent)
{
	this.pagina = event.pageIndex;
    //possible call to a function in a service to get data from one index to another one
   
} 
}
